import template from './vat-type.jade';
import items from '../../../enums/vat-type';
import itemsV2 from '../../../enums/vat-type-v2';
import validation from '../../../services/validation';

import './vat-type.styl';
import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

export default angular
  .module('cian.addForm.vatType', ['cian.addForm.fieldTypeDropdown'])
  .directive('cianAfPriceAndDealTermsVatType', () => ({
    scope: {},
    bindToController: {
      ad: '=?',
      form: '=?',
      defaultValue: '=?',
      getCustomMessage: '=?',
    },
    controller(store, config) {
      'ngInject';

      /**
       * @todo Удалить строку с RS
       * @description Данный функционал появился в задаче CD-142982, будет удалён в задаче CD-143177
       */
      const commercialNewVatTextEnabled = !!config.get('Commercial.NewVatText.Enabled');

      /**
       * @todo Удалить строку с RS и сделать V2 просто items
       * @description Данный функционал появился в задаче CD-142982, будет удалён в задаче CD-143177
       */
      this.items = commercialNewVatTextEnabled ? itemsV2 : items;

      this.validation = validation(this.form, 'vatType', {
        required: 'Укажите тип налога',
      });

      this.handleChange = () => {
        const state = store.getState();
        const category = selectAnalyticsOfferStatus(state);

        trackRequiredFieldFill(category, 'tax');
      };
    },
    controllerAs: 'vatType',
    template,
  })).name;
